import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/lucide-react@1.52.0_@types+react@19.3.0_react@19.3.0/node_modules/lucide-react/dist/esm/Icon.mjs");
